import { ImportParser, QtyAndName } from './import-parser.interface';
import { EditableDataField } from '../../../common/filter/editable-data-field';

export class GenericParser extends ImportParser {

    constructor(private readonly delimiter: string, private readonly columns: EditableDataField[]) {
        super();
    }

    public parse(text: string): QtyAndName[] | null {
        let p = '';
        let row = [''];
        const rows = [row];
        let columnIndex = 0;
        let rowIndex = 0;
        let s = !0;
        let character;
        for (character of text) {
            if ('"' === character) {
                if (s && character === p) {
                    row[columnIndex] += character;
                }
                s = !s;
            } else if (this.delimiter === character && s) {
                character = row[++columnIndex] = '';
            } else if ('\n' === character && s) {
                if ('\r' === p) {
                    row[columnIndex] = row[columnIndex].slice(0, -1);
                }
                row = rows[++rowIndex] = [character = '']; columnIndex = 0;
            } else {
                row[columnIndex] += character;
            }
            p = character;
        }
        return rows as any;
    }

}
